import { Routes } from '@angular/router';
import { UwCopilotTriagePage } from './features/copilot/copilot-triage-page';
import { UwCopilotAccountPage } from './features/copilot/copilot-account-page';
import { ClassicIngestionPage, ClassicSubmissionsPage } from './features/classic/intake-pages';
import { ClassicAccountPage } from './features/classic/classic-account-page';
import { ClassicSectionPage } from './features/classic/classic-section-page';
import { LoginComponent } from './core/authentication/login/login.component';
import { ForgotPasswordComponent } from './core/authentication/forgot-password/forgot-password.component';
import { AppShell } from './layout/app-shell/app-shell';
import { authGuard, authChildGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';

export const routes: Routes = [
  {
    path: 'authentication',
    canActivate: [guestGuard],
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: '', pathMatch: 'full', redirectTo: 'login' },
    ]
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authChildGuard],
    component: AppShell,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'workbench' },
      { path: 'workbench', component: UwCopilotTriagePage },
      { path: 'workbench/account/:id', component: UwCopilotAccountPage },
      { path: 'classic/submissions', component: ClassicSubmissionsPage },
      { path: 'classic/ingestion', component: ClassicIngestionPage },
      { path: 'classic/account/:id', component: ClassicAccountPage },
      { path: 'classic/:section', component: ClassicSectionPage },
    ]
  },
  { path: '**', redirectTo: 'workbench' },
];
